/** Invite-phase card for the welcome plan tour (dump more tasks). */
import { Box, Button, Paper, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS } from '@/features/onboarding/constants/welcomePlanTour';
import { onboardingHintCardPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';

/**
 * @param {Object} props
 * @param {'context' | 'duration' | null} props.dumpHint
 * @param {number} [props.newDumpCount]
 * @param {() => void} props.skipInvite
 */
const OnboardingWelcomePlanTourInvite = ({
  dumpHint,
  newDumpCount = 0,
  skipInvite,
}) => {
  const t = useT();
  let finishLabel = t('onboarding.more.skip', 'Overslaan');
  let finishVariant = 'text';
  if (newDumpCount > 0) {
    finishLabel = t('onboarding.more.done', 'Klaar');
    finishVariant = 'contained';
  }

  return (
    <Paper
      variant="outlined"
      data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.invite}
      sx={{
        ...onboardingHintCardPositionSx,
        pointerEvents: 'none',
      }}
      role="region"
      aria-labelledby="onboarding-welcome-plan-invite-title"
    >
      <Box sx={{ pointerEvents: 'auto' }}>
        <Typography
          id="onboarding-welcome-plan-invite-title"
          variant="subtitle1"
          component="h2"
          gutterBottom
        >
          {t('onboarding.more.title', 'Nog meer op je lijst?')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t(
            'onboarding.more.body',
            'Voeg toe wat je wil, zo veel als je wil.',
          )}
        </Typography>
        {dumpHint === 'context' ? (
          <Typography
            variant="body2"
            data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.contextHint}
            sx={{ mb: 1 }}
          >
            {t(
              'onboarding.more.contextPrompt',
              'Wanneer of waar doe je dit? Zet er @thuis of @onderweg bij.',
            )}
          </Typography>
        ) : null}
        {dumpHint === 'duration' ? (
          <Box sx={{ mb: 1 }}>
            <Typography
              variant="body2"
              data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.durationHint}
            >
              {t(
                'onboarding.more.durationPrompt',
                'Hoe lang duurt dit ongeveer? Zet er `~30m` of `~1u` bij.',
              )}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              {t(
                'onboarding.more.durationDefault',
                'Laat je hem leeg, dan geldt 15 minuten.',
              )}
            </Typography>
          </Box>
        ) : null}
        <Typography variant="caption" color="text.secondary" display="block">
          {t(
            'onboarding.more.laterHint',
            'Je kan dit altijd later aanvullen.',
          )}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
          <Button variant={finishVariant} size="small" onClick={skipInvite}>
            {finishLabel}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default OnboardingWelcomePlanTourInvite;
